import { getLocationOrigin, getUrlCountryPath } from 'utils/urlUtils';
import { getEnvApiConfigValues } from 'utils/envUtils';
import { owaAuth } from './owaApi';
import { docCheckAuth } from './doccheckApi';
import {
  createUserToken,
  verifyUserToken,
  refreshUserToken,
  registerNewUser,
  deleteUser,
  fetchUserDetails,
  updateUserDetails,
  forgottenPassword,
  passwordReset,
  changeUserPassword,
  updateUserConsent,
} from './genericApi';
import { hcaAuth } from './hcaApi';
import { DOCCHECK_AUTH, HCA_AUTH, KKI_AUTH, OWA_AUTH } from 'utils/authUtils';

const GENERIC = 'generic';
const KKI = 'kki';
const ONEKEY = 'oneKey';
const DOCCHECK = 'docCheck';
const HCA = 'hca';
const { owasecureURL,oneKeyUrl } = getEnvApiConfigValues();

const authService = {
  service: {
    generic: {
      redirects: null,
      api: {
        consent: {
          update: updateUserConsent,
        },
        token: {
          verify: verifyUserToken,
          refresh: refreshUserToken,
        },
        user: {
          details: {
            fetch: fetchUserDetails,
            update: updateUserDetails,
            deleteExternal: owaAuth.deleteUser,
          },
        },
      },
    },
    kki: {
      redirects: null,
      api: {
        token: {
          create: createUserToken,
        },
        user: {
          register: registerNewUser,
          delete: deleteUser,
          password: {
            forgot: forgottenPassword,
            reset: passwordReset,
            change: changeUserPassword,
          },
        },
      },
    },
    oneKey: {
      redirects: {
        register: owaAuth.owaRegisterRedirect,
        login: owaAuth.owaLoginRedirect,
        account: () => `${owasecureURL}login?_flowId=myaccount-webflow`,
        logout: () => `${owasecureURL}logout?service=${getLocationOrigin()}/${getUrlCountryPath()}/?action=logged-out`,
      },
      api: {
        token: {
          create: owaAuth.createUserToken,
        },
        callExtendedUserProfile: {
          extendedUserProfile: owaAuth.callExtendedUserProfile,
        },
      },
    },
    docCheck: {
      redirects: {
        register: docCheckAuth.docCheckRegisterRedirect,
        login: docCheckAuth.docCheckLoginRedirect,
      },
      api: {
        token: {
          create: docCheckAuth.createUserToken,
        },
      },
    },
    hca: {
      redirects: {
        register: hcaAuth.hcaRegisterRedirect,
        login: hcaAuth.hcaLoginRedirect,
        logout: hcaAuth.hcaLogout,
        account: () => `${oneKeyUrl}/login?_flowId=myaccount-webflow`,
       
      },
      api: {
        token: {
          create: hcaAuth.createUserToken
        }
      }
    }
  },
};

const getAuthServiceName = ({ service = null } = {}) => {
  switch (service) {
    case KKI_AUTH:
      return KKI;
    case OWA_AUTH:
      return ONEKEY;
    case DOCCHECK_AUTH:
      return DOCCHECK;
    case HCA_AUTH:
        return HCA;
    default:
      return null;
  }
}

const getAuthService = ({ service = null } = {}) => (service ? authService.service[service] : authService.service.generic);
const getAuthServiceAPI = ({ service = null } = {}) => getAuthService({ service }).api;
const getAuthServiceRedirects = ({ service = null } = {}) => getAuthService({ service }).redirects;

export {
  GENERIC,
  KKI,
  ONEKEY,
  DOCCHECK,
  HCA,
  getAuthService,
  getAuthServiceAPI,
  getAuthServiceRedirects,
  getAuthServiceName,
};
